import { is, isEmpty } from 'ramda';

/**
 * Helper function to verify that passed argument is a valid
 * object with content. Used both as a truthty value and as a plucker
 * @function isObjectWithContent
 * @param {Object} object
 * @returns {Boolean}
 */
export const isObjectWithContent = object => {
	if (is(Object, object) && !isEmpty(object)) {
		return true;
	}
	return false;
};

export default isObjectWithContent;
